//#region Icons
import CalendarIcon from "icons/CalendarIcon";
import TimerIcon from "icons/TimerIcon";
import PersonIcon from "icons/PersonIcon";
import LocationIcon from "icons/LocationIcon";
//#endregion
//#region Utils
import { 
    DAY_IN_MILLIS, 
    getDatePartsByMillis, 
    getToday, 
    getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
import OpenEyeIcon from "icons/OpenEyeIcon";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion

const HEADER_LABELS = {
    ACAD_REINFORCE_NAME: "Nombre de refuerzo",
    DATE: "Fecha",
    TIME: "Horas",
    LOCATION: "Ubicación",
    TUTOR: "Docente/Ponente",
    STATE: "Estado"
};
const HEADERS_TABLE_LIST_ADMIN = [
    { title: HEADER_LABELS.ACAD_REINFORCE_NAME }, 
    { title: HEADER_LABELS.DATE, icon: <CalendarIcon/> },
    { title: HEADER_LABELS.TIME, icon: <TimerIcon/> }, 
    { title: HEADER_LABELS.TUTOR, icon: <PersonIcon/> }, 
    { title: HEADER_LABELS.LOCATION, icon: <LocationIcon/> }
];
export const HEADERS_TABLE_LIST = {
    ADMIN: [...HEADERS_TABLE_LIST_ADMIN],
    ADMIN_WITH_STATE: [
        ...HEADERS_TABLE_LIST_ADMIN,
        { title: HEADER_LABELS.STATE, icon: <OpenEyeIcon/> }
    ],
    TUTOR: [
        { title: HEADER_LABELS.ACAD_REINFORCE_NAME }, 
        { title: HEADER_LABELS.DATE, icon: <CalendarIcon/> },
        { title: HEADER_LABELS.TIME, icon: <TimerIcon/> }, 
        { title: HEADER_LABELS.LOCATION, icon: <LocationIcon/> }
    ]
};
export const TAB_DATA_VALUES = {
    ADMIN: {
        GENERAL: 0,
        PAST: 1,
        DRAFT: 2,
        CANCELED: 3,
        UNPROCESSED: 4
    },
    TUTOR: {
        GENERAL: 0,
        PAST: 1,
        CANCELED: 2
    }
};
export const ACAD_REINFORCE_STATE_UNPROCESSED_TAB = {
    PENDING: "N",
    UPDATED: "A",
    PROCESSED: "C",
    UNPROCESSED: "E"
};
export const ACAD_REINFORCE_STATE_UNPROCESSED_TAB_BY_TEXT = {
    [ACAD_REINFORCE_STATE_UNPROCESSED_TAB.PENDING]: "Pendiente",
    [ACAD_REINFORCE_STATE_UNPROCESSED_TAB.UPDATED]: "Actualizado",
    [ACAD_REINFORCE_STATE_UNPROCESSED_TAB.PROCESSED]: "Procesado",
    [ACAD_REINFORCE_STATE_UNPROCESSED_TAB.UNPROCESSED]: "No Procesado",
};
export const TAB_DATA_FIELDS = {
    ADMIN: {
        [TAB_DATA_VALUES.ADMIN.GENERAL]: "general",
        [TAB_DATA_VALUES.ADMIN.PAST]: "past",
        [TAB_DATA_VALUES.ADMIN.DRAFT]: "draft",
        [TAB_DATA_VALUES.ADMIN.CANCELED]: "canceled",
        [TAB_DATA_VALUES.ADMIN.UNPROCESSED]: "unprocessed"
    },
    TUTOR: {
        [TAB_DATA_VALUES.TUTOR.GENERAL]: "general",
        [TAB_DATA_VALUES.TUTOR.PAST]: "past",
        [TAB_DATA_VALUES.TUTOR.CANCELED]: "canceled"
    }
};
export const TAB_DATA_FOR_FILTER_TYPE = {
    ADMIN: {
        [TAB_DATA_VALUES.ADMIN.GENERAL]: 1,
        [TAB_DATA_VALUES.ADMIN.PAST]: 2,
        [TAB_DATA_VALUES.ADMIN.DRAFT]: 3,
        [TAB_DATA_VALUES.ADMIN.CANCELED]: 4,
        [TAB_DATA_VALUES.ADMIN.UNPROCESSED]: 5
    },
    TUTOR: {
        [TAB_DATA_VALUES.TUTOR.GENERAL]: 1,
        [TAB_DATA_VALUES.TUTOR.PAST]: 2,
        [TAB_DATA_VALUES.TUTOR.CANCELED]: 4
    }
};
export const RECORDS_BY_PAGE = 10;
const SIX_MONTHS = DAY_IN_MILLIS*30*6;
const DATE_PERIOD_FILTERS = {
    GENERAL: {
        min: getToday(),
        max: [3000, 1, 1]
    },
    PAST: {
        min: getDatePartsByMillis(getTodayWithoutHourInMillis() - SIX_MONTHS),
        max: getDatePartsByMillis(getTodayWithoutHourInMillis() - DAY_IN_MILLIS)
    },
    DRAFT: {
        min: getDatePartsByMillis(getTodayWithoutHourInMillis() - SIX_MONTHS),
        max: [3000, 1, 1]
    },
    CANCELED: {
        min: getDatePartsByMillis(getTodayWithoutHourInMillis() - SIX_MONTHS),
        max: [3000, 1, 1]
    },
    UNPROCESSED: {
        min: getToday(),
        max: [3000, 1, 1]
    }
};
export const getDatePeriodFilters = isTutorUser => {
    if (isTutorUser) 
        return {
            [TAB_DATA_VALUES.TUTOR.GENERAL]: DATE_PERIOD_FILTERS.GENERAL,
            [TAB_DATA_VALUES.TUTOR.PAST]: DATE_PERIOD_FILTERS.PAST,
            [TAB_DATA_VALUES.TUTOR.CANCELED]: DATE_PERIOD_FILTERS.CANCELED
        };
    return {
        [TAB_DATA_VALUES.ADMIN.GENERAL]: DATE_PERIOD_FILTERS.GENERAL,
        [TAB_DATA_VALUES.ADMIN.PAST]: DATE_PERIOD_FILTERS.PAST,
        [TAB_DATA_VALUES.ADMIN.DRAFT]: DATE_PERIOD_FILTERS.DRAFT,
        [TAB_DATA_VALUES.ADMIN.CANCELED]: DATE_PERIOD_FILTERS.CANCELED,
        [TAB_DATA_VALUES.ADMIN.UNPROCESSED]: DATE_PERIOD_FILTERS.UNPROCESSED
    };
}
export const INIT_FILTER_FIELDS = {
    title: "", 
    date: -1,
    acadReinforceTypeId: 0,
    tutorId: "",
    locationId: 0,
    campusId: 0
};

export const CREATE_ACAD_REINFORCE_DROPDOWN_OPTIONS = [
    { 
        path: ABSOLUTE_PATHS.CREATE_ACAD_REINFORCE_MANUAL_LOADING, 
        text: "Carga manual" 
    },
    {
        path: ABSOLUTE_PATHS.CREATE_ACAD_REINFORCE_MASSIVE_LOADING, 
        text: "Carga masiva" 
    }
];